import { types, flow, getParent, getRoot } from "mobx-state-tree"

import { STATES, PARKING_SEARCH_TYPE } from "~/utilities/constants"
import PARKING_SEARCH_CRITERIA_VALIDATIONS from "~/utilities/parkingSearchCriteriaValidations"
import buildCustomValidationStore from "~/stores/models/customValidation"
import TRACKING from "~/services/tracking"

const SearchCriteriaBaseStore = types
  .model("SearchCriteriaBaseStore", {
    ticketId: types.optional(types.string, ""),
    plateNumber: types.optional(types.string, ""),
    plateState: types.optional(types.enumeration(Object.keys(STATES)), "NY"),
    type: types.optional(
      types.enumeration(Object.keys(PARKING_SEARCH_TYPE)),
      PARKING_SEARCH_TYPE.plate
    )
  })
  .views(self => ({
    get searchData() {
      switch (self.type) {
        default:
        case PARKING_SEARCH_TYPE.plate:
          return {
            plateNumber: self.plateNumber,
            state: self.plateState
          }
        case PARKING_SEARCH_TYPE.ticketId:
          return {
            ticketId: self.ticketId
          }
      }
    },
    get flowValidateKeys() {
      switch (self.type) {
        default:
        case PARKING_SEARCH_TYPE.plate:
          return ["plateNumber", "plateState"]
        case PARKING_SEARCH_TYPE.ticketId:
          return ["ticketId"]
      }
    },
    get hasErrors() {
      return self.validateKeys(self.flowValidateKeys)
    }
  }))
  .actions(self => ({
    changeSearchType(type) {
      self.type = type
    },
    setTicketId(input) {
      self.changeKey("ticketId", input.trim())
    },
    setPlateNumber(input) {
      self.changeKey("plateNumber", input.trim().toUpperCase())
    },
    setPlateState(state) {
      self.changeKey("plateState", state)
    },
    fetchTickets: flow(function* fetchTicketsGen(urlLocation, currentHost) {
      const { auth } = getRoot(self)
      const { contactInfo } = getParent(self)
      const parkingStore = getParent(self)
      self.resetTouched()
      self.resetDisplayErrors()
      self.validateKeyList(self.flowValidateKeys)
      if (!self.hasDisplayErrors) {
        const { ui } = getRoot(self)
        if (ui.isPayNYCFlow) {
          TRACKING.paynycParking.search(ui.isPayNYCFlow, self.type, self.plateState)
        }
        const result = yield parkingStore.results.fetch(self.searchData,urlLocation, currentHost)
        if (!auth.isLoggedIn) {
          contactInfo.writePropertiesOnUser()
        }
        return result
      }
      return false
    })
  }))

const CustomValidationStore = buildCustomValidationStore({
  validationObject: PARKING_SEARCH_CRITERIA_VALIDATIONS
})

export const SearchCriteriaStore = types.compose(
  SearchCriteriaBaseStore,
  CustomValidationStore
)
